// src/components/layout/MainLayout.tsx
import { Outlet, Navigate } from 'react-router-dom';
import { Sidebar } from './sidebar/Sidebar';
import { useAuth } from '@/hooks/useAuth';
import { LoadingSpinner } from '@/components/common/LoadingSpinner';
import { Breadcrumb } from "./Breadcrumb";

export function MainLayout() {
  const { user, isLoading } = useAuth();

  if (isLoading) {
    return (
      <div className="flex h-screen items-center justify-center">
        <LoadingSpinner size="lg" />
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  return (
    <div className="flex min-h-screen flex-col">
      <Sidebar />
      <main className="flex-1">
        {/* Main content with breadcrumb */}
        <div className="container mx-auto px-6 py-8">
          <Breadcrumb />
          <Outlet />
        </div>
      </main>
    </div>
  );
}